import * as amplitude from "@amplitude/analytics-browser";
import { useEffect } from "react";
import config from "@/config";
import { useUser } from "@clerk/clerk-react";
import rollbar from "@/lib/rollbar";
import { FullStory, init as initFullStory } from "@fullstory/browser";

export function Anal() {
  const { user } = useUser();

  useEffect(() => {
    if (config.amplitude) {
      amplitude.init(
        config.amplitude,
        user?.primaryEmailAddress?.emailAddress,
        {
          defaultTracking: {
            sessions: true,
            pageViews: true,
            formInteractions: false,
            fileDownloads: false,
          },
        }
      );
    }

    if (user) {
      rollbar.configure({
        payload: {
          person: {
            id: user.id,
            email: user.primaryEmailAddress?.emailAddress,
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.primaryEmailAddress?.emailAddress]);

  useEffect(() => {
    if (!user?.primaryEmailAddress?.emailAddress) return;

    const email = user.primaryEmailAddress.emailAddress;

    amplitude.setUserId(email);

    const identifyEvent = new amplitude.Identify();
    amplitude.identify(identifyEvent);

    FullStory("setIdentity", {
      uid: user.id,
      properties: {
        email,
      },
    });
  }, [user]);

  useEffect(() => {
    if (config.fullstory) {
      initFullStory({ orgId: config.fullstory });
    }
  }, []);

  return null;
}
